import type { InboxCategory } from '@stuut/api/models';

export const EMAIL_OBJECT_TYPE = 'email';
export const EMAIL_THREAD_OBJECT_TYPE = 'email_thread';

interface RouteToInboxParams {
  entityId?: string | null;
  inboxCategory?: InboxCategory;
  router: any;
  type: 'calls' | 'emails';
}

export const getEntityObjectType = (entityId: string): string => {
  if (!entityId) {
    return '';
  }
  if (entityId.startsWith('eml_th_')) {
    return EMAIL_THREAD_OBJECT_TYPE;
  } else if (entityId.startsWith('eml_')) {
    return EMAIL_OBJECT_TYPE;
  }
  return '';
};

export const routeToInbox = ({
  entityId,
  inboxCategory,
  router,
  type,
}: RouteToInboxParams): void => {
  const route = buildRoute(type, entityId, inboxCategory);
  router.push(route);
};

const buildRoute = (
  type: 'calls' | 'emails',
  entityId?: string | null,
  inboxCategory?: InboxCategory,
): {
  name: string;
  params?: Record<string, string>;
  query?: { category: InboxCategory };
} => {
  let name: string;

  if (entityId) {
    if (type === 'emails') {
      name = 'collection.emails.email';
    } else {
      name = 'collection.calls.call';
    }
    return { name, params: { id: entityId } };
  }

  if (type === 'emails' && inboxCategory) {
    return {
      name: 'collection.emails.email',
      query: { category: inboxCategory },
    };
  }

  return {
    name: 'collection.calls',
  };
};
